import { FC, useCallback, useContext, useEffect } from 'react';

import { Typography } from 'antd';

import {
  ColSize,
  RadioForm,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import {
  capitalizeFirstLetter,
  ValidateForm,
} from '../../../../../../../../../../../shared/utils';

import { StepTwoFormContext } from '../../../../contexts/StepTwoForm';

import { COLORS } from '../../../../../../../../../../../config/themes/colors';
import { DECISION_TYPE, OPTION_YES_OR_NOT } from '../../../../../../../../../../../shared/interfaces';

import './index.css';
import { WizardDataFormContext } from '../../../../../../Wizard/contexts/WizardDataForm';

interface AdditionalDataProps {
  duplicateId?: number;
  id: number;
}

export const AdditionalData: FC<AdditionalDataProps> = ({
  duplicateId,
  id,
}) => {
  const validateForm = new ValidateForm();

  const { scoringQuestions } = useContext(StepTwoFormContext);
  const { stepTwoForm } = useContext(WizardDataFormContext);

  const handleDuplicatePlan = useCallback(() => {
    if (duplicateId) {
      const allFieldsValues = stepTwoForm?.getFieldsValue(true);

      const duplicatedFieldsValues = Object.keys(allFieldsValues).reduce(
        (acc, key) => {
          if (key.includes(`-tab-${duplicateId}`)) {
            const newKey = key.replace(`-tab-${duplicateId}`, `-tab-${id}`);
            acc[newKey] = allFieldsValues[key];
          }

          return acc;
        },
        {} as Record<string, any>
      );

      stepTwoForm?.setFieldsValue(duplicatedFieldsValues);
    }
  }, [duplicateId, stepTwoForm, id]);

  useEffect(() => {
    handleDuplicatePlan();
    /* eslint-disable-next-line */
  }, []);

  return (
    <div className='additional-data-form-container'>
      <RowSize>
        <Typography.Title
          level={3}
          style={{
            margin: 0,
            marginBottom: 10,
            color: COLORS.secondary[100],
          }}
        >
          Información Adicional
        </Typography.Title>
      </RowSize>

      <RowSize>
        {scoringQuestions.map((question) => {
          const questionLabel = capitalizeFirstLetter(question.descripcion);

          return (
            <ColSize size={25} key={question.codigo}>
              <RadioForm
                formProps={{
                  label: questionLabel,
                  name: `${question.codigo}-tab-${id}`,
                  hasFeedback: question.obligatoria === DECISION_TYPE.YES,
                  required: question.obligatoria === DECISION_TYPE.YES,
                  rules: validateForm.generateRules({
                    label: '',
                    rules: ['required'],
                  }),
                  className: 'additional-data-radio-form-item',
                }}
                options={OPTION_YES_OR_NOT}
              />
            </ColSize>
          );
        })}
      </RowSize>
    </div>
  );
};
